<template>
  <div class="result">
    <div class="header">
      <div class="title">
        <template v-if="hasAll">
          已选素材
          ({{total}})
        </template>
        <template v-else>
          已上传创意
        </template>
       </div>
      <span v-if="!hasAll" class="text-color-gray">每一行为一组创意，每一组必填的素材尺寸不可有空</span>
      <div class="del-all"><el-button type="text" @click="handleDelAll">清空</el-button></div>
    </div>
    <div class="content">
      <el-table
        :data="tableData"
        :header-cell-style="{background:'#e8eaec',color:'#333'}"
        row-key="index"
      >
        <el-table-column
          v-if="!hasAll"
          width="46"
          prop="index"
          label="序号"
        />
        <el-table-column
          v-for="(item, index) in tableColumn"
          :key="item.prop"
          :prop="item.prop"
          :label="item.label"
          align="center"
          :min-width="hasAutoGenerate&&item.label==='预览图'?'140':'auto'"
        >
          <template slot="header">
            <span v-if="item.required" style="color:red">*</span>
            {{item.label}}
            <template v-if="hasAll">
              ({{item.num}})
            </template>
            <template v-if="hasAutoGenerate&&item.label==='预览图'" >
              <el-button
                size="mini"
                type="primary"
                plain
                :disabled="loading"
                @click="handleAutoGenerate"
              >
                {{ loading?'生成中...' : '自动生成' }}
              </el-button>
            </template>
          </template>
          <template

              slot-scope="{ row }">
            <MaterialItem
              v-if="row[item.prop]"
              :file="row[item.prop]"
              :type="row[item.prop].material_type == 1?'image':'video'"
              @remove="()=> $emit('remove', item.prop, row.id, tableProps)"
              @copy="()=>$emit('copy', row[item.prop], 'select', item)"
            />
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import MaterialItem from '../materialItem'
export default {
    name: 'ResultBox',
    props: [ 'list', 'config', 'loading' ],
    components: { MaterialItem },
     inject: {
        hasAll: {
            default: false
        }
    },
    data() {
      return {
      }
    },
    computed: {
      total() {
        return this.tableColumn.reduce((pre, item)=> {
          pre+=item.num
          return pre;
        }, 0)
      },
      tableColumn() {
        const list = this.config.map(v=> {
          return {
            ...v,
            label: v.explicit_name,
            prop: v.explicit_name,
            required: v.material_is_null === '0',
            num: this.tableData.reduce((pre, item)=> {
              if (item[v.explicit_name]) {
                ++pre
              }
              return pre;
            }, 0)
          }
        })
        return [
           ...list
        ]
      },
      tableProps() {
        return this.tableColumn.map(v=> v.prop)
      },
      tableData() {
        if (this.hasAll) {
          return  [ ...this.list.map((v, i)=> {
            return {
              ...v,
              index: i+1
            }
          }) ]
        }
        return [ ...this.list.map((v, i)=> {
          return {
            ...v,
            index: i+1
          }
        }) ].reverse()
      },
      hasAutoGenerate() {
        const data = this.tableColumn.find(v=> v.material_type === '3')
        return this.tableColumn.length>1 && !!data
      }
    },
    methods: {
      handleAutoGenerate() {
        this.$emit('auto-generate', this.tableColumn)
      },
      handleDelAll() {
        if (!this.tableData.length) {
          this.$message.error('当前没有选中的素材，请添加')
          return
        }
        this.$confirm('将删除所有已选择的素材，是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
           this.$emit('del-all')
        }).catch(() => {});
      }
    }
}
</script>

<style lang="scss" scoped>
.result {
  height: 100%;
  display: flex;
  flex-direction: column;
  .content {
    flex: 1;
    height: 0;
    overflow: auto;
    padding: 10px 8px;
  }
}
.header {
  display: flex;
  height: 40px;
  line-height: 40px;
  .title {
    font-size: 14px;
    font-weight: bold;
    padding-left: 8px;
    margin-right: 8px;
  }
  span {
    font-size: 12px;
  }
}

</style>
